import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

const ChannelListDescriptionContainer = styled.div<{ focused?: boolean }>`
  display: flex;
  flex-direction: column;
  left: ${523 * Screen.widthRatio}px;
  top: ${120 * Screen.widthRatio}px;
  width: 100%;
  transition: ${TRANSITION.CHANNEL_LIST_CONTENT};
`;

export default ChannelListDescriptionContainer;
